import {
  useGetDashboardMetrics,
  useGetDashboardFormalityRequests,
} from "@/queries/dashboard/dashboard.api";
import { MetricsRow } from "./metrics-row";
import { RequestsRow } from "./requests-row";

const Metrics = () => {
  const {
    data: metricsData,
    isLoading: isLoadingMetrics,
    isFetching: isFetchingMetrics,
    refetch: refetchMetrics,
  } = useGetDashboardMetrics();
  const {
    data: formalityRequestsData,
    isLoading: isLoadingFormalityRequests,
    isFetching: isFetchingFormalityRequests,
    refetch: refetchFormalityRequests,
  } = useGetDashboardFormalityRequests();

  const isLoadingMetricsSection = isLoadingMetrics || isFetchingMetrics;
  const isLoadingFormalityRequestsSection =
    isLoadingFormalityRequests || isFetchingFormalityRequests;

  return (
    <>
      <MetricsRow
        isFetching={isFetchingMetrics}
        isLoading={isLoadingMetricsSection}
        data={metricsData}
        refetch={refetchMetrics}
      />
      <RequestsRow
        isLoading={isLoadingFormalityRequestsSection}
        isFetching={isFetchingFormalityRequests}
        data={formalityRequestsData}
        refetch={refetchFormalityRequests}
      />
    </>
  );
};

export default Metrics;
